import { FC, ReactNode } from 'react';
import cn from 'classnames';
import styles from './style.module.scss';

type Props = {
    className?: string;
    fullWidth?: boolean;
    children: ReactNode;
    center?: boolean;
}

const Container: FC<Props> = ({ className, fullWidth, children, center }) => (
    <div className={cn(styles.container, { [className || '']: className, [styles.fullWidth]: fullWidth, [styles.center]: center })}>{children}</div>
);

export default Container;
